import { ISoilProfileModel, ISoilRegionModel, ISoilRegionResModel, ISoilProfileGetCountriesResModel, ISoilProfileValidateStatusResModel} from '../../util/Request/requestType';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

interface ISoilPageModel {
    soilProfilesList: ISoilProfileModel[]
    originalProfileList: ISoilProfileModel[]
    regionSoilProfileList: (ISoilProfileModel | ICountryName)[]
    regionsMap?: ISoilRegionModel
    regionIds?: ISoilRegionResModel[]
    countries?: {number?: ISoilProfileGetCountriesResModel[]}
    validateStatus: ISoilProfileValidateStatusResModel[]
    pageSize: number
    pageIndex: number
    profilesCount?: number
}


interface ICountryName {
    countryNameSection: string
}

const initialState: ISoilPageModel = {
    soilProfilesList: [],
    originalProfileList: [],
    regionSoilProfileList: [],
    validateStatus: [],
    regionsMap: {
        Africa: 1,
        Antarctica: 2,
        Asia: 3,
        Europe: 4,
        ['North America']: 5,
        ['South America']: 6,
        Oceania: 7
    },
    pageSize: 15,
    pageIndex: 1,
    profilesCount: 0
};

export const soilprofilesSlice = createSlice({
    name: 'soilprofilesList',
    initialState,
    reducers: {
        refresh: (state, action: PayloadAction<{soilProfilesList: ISoilProfileModel[], originalProfileList: ISoilProfileModel[]}>) => {
            console.log('refresh');
            return {
                ...state,
                soilProfilesList: action.payload.soilProfilesList,
                originalProfileList: action.payload.originalProfileList,
                // if the table refresh reset the pageIndex to 2
                pageIndex: 2
            };
        },
        loadMore: (state, action: PayloadAction<{soilProfilesList: ISoilProfileModel[], originalProfileList: ISoilProfileModel[]}>) => {
            console.log('loadMore');

            const newSoilprofiles = [...state.soilProfilesList, ...action.payload.soilProfilesList];
            const newOriginSoilprofiles = [...state.originalProfileList, ...action.payload.originalProfileList];
            return {
                ...state,
                soilProfilesList: newSoilprofiles,
                originalProfileList: newOriginSoilprofiles,
                pageIndex: state.pageIndex + 1
            };
        },
        // because of split by region need to split every time
        loadMoreBaseOnRegion: (state, action: PayloadAction<{soilProfilesList: ISoilProfileModel[], originalProfileList: ISoilProfileModel[]}>) => {
            console.log('loadMoreBaseOnRegion');
            const newOriginSoilprofiles = [...state.originalProfileList, ...action.payload.originalProfileList];
            return {
                ...state,
                soilProfilesList: action.payload.soilProfilesList,
                originalProfileList: newOriginSoilprofiles,
                pageIndex: state.pageIndex + 1
            };
        },
        refreshCurrentProfileList: (state, action: PayloadAction<{soilProfilesList: ISoilProfileModel[]}>) => {
            return {
                ...state,
                soilProfilesList: action.payload.soilProfilesList
            };
        },
        loadRegionFromServer: (state, action: PayloadAction<ISoilRegionResModel[]>) => {
            const regionsMap = {...state.regionsMap};
            action.payload.forEach((regionObj) => {
                regionsMap[regionObj.regionName] = regionObj.regionId;
            });
            // console.log
            return {
                ...state,
                regionsMap,
                regionIds: action.payload
            };
        },
        loadingCountryFromServer: (state, action: PayloadAction<{number?: ISoilProfileGetCountriesResModel[]}>) => {
            return {
                ...state,
                countries: action.payload
            };
        },
        updateProfilesCount: (state, action: PayloadAction<number>) => {
            return {
                ...state,
                profilesCount: action.payload
            };
        },
        deleteSpecifyItem: (state, action: PayloadAction<number[]>) => {
            const originalProfileList = state.originalProfileList;
            const profilesList = state.soilProfilesList;
            const newSoilProfilesList = profilesList.filter((item) => {
                let include= false;
                action.payload.forEach((deleteItem) => {
                    include = deleteItem !== item.id;
                });
                return include;
            });

            const newOriginalProfileList = originalProfileList.filter((item) => {
                let include= false;
                action.payload.forEach((deleteItem) => {
                    include = deleteItem !== item.id;
                });
                return include;
            });

            return {
                ...state,
                soilProfilesList: newSoilProfilesList,
                originalProfileList: newOriginalProfileList
            };
        },
        updateRegionSoilProfileList: (
            state,
            action: PayloadAction<ISoilProfileModel[]>) => {
            return {
                ...state,
                regionSoilProfileList: action.payload
            };
        },
        filterOrSortTargetPropertySoilPrfofileList: (state, action: PayloadAction<ISoilProfileModel[]>) => {
            return {
                ...state,
                soilProfilesList: [...action.payload]
            };
        },
        updateValidateStatus: (state, action: PayloadAction<ISoilProfileValidateStatusResModel[]>) => {
            return {
                ...state,
                validateStatus: [...action.payload]
            };
        },
    }
});

export type {
    ISoilPageModel,
    ICountryName
};

export const {
    refresh,
    loadMore,
    loadRegionFromServer,
    loadingCountryFromServer,
    updateProfilesCount,
    updateRegionSoilProfileList,
    filterOrSortTargetPropertySoilPrfofileList,
    updateValidateStatus,
    loadMoreBaseOnRegion,
    refreshCurrentProfileList
} = soilprofilesSlice.actions;

export const selectSoilProfilesList = (state:RootState) => state.soilPageData;
export default soilprofilesSlice.reducer;